import { ApiDef_Referencable, DBDef_Referencable } from '@app/hcs-shared/hcs-v2';
import { apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { filterDuplicates, filterInstances, MissingDataException } from '@nu-art/ts-common';
export const dispatch_onReferencablesUpdated = new ThunderDispatcherV3('__onReferencablesUpdated');
export class ModuleFE_Referencable_Class extends ModuleFE_BaseApi {
    v2;
    constructor() {
        super(DBDef_Referencable, dispatch_onReferencablesUpdated);
        this.v2 = {
            setup: apiWithQuery(ApiDef_Referencable.v2['setup'], async (response, params, request) => {
                await this.onEntriesUpdated(response.initialEntities, false);
            }),
        };
    }
    inferPropIds = (_referencable) => {
        const referencable = typeof _referencable === 'string' ? this.cache.unique(_referencable) : _referencable;
        if (!referencable)
            throw new MissingDataException(`Could not find item for id ${referencable}`);
        const propIds = [...referencable.prototypes.map(prototype => prototype.id)];
        let parentIds = referencable.extends;
        while (parentIds?.length) {
            const parents = filterInstances(parentIds.map(id => this.cache.unique(id)));
            parentIds = parents.map(parent => parent.extends.filter(id => id !== parent._id)).flat();
            propIds.push(...parents.map(parent => parent.prototypes.map(prototype => prototype.id)).flat());
        }
        return filterDuplicates(propIds);
    };
}
export const ModuleFE_Referencable = new ModuleFE_Referencable_Class();
//# sourceMappingURL=ModuleFE_Referencable.js.map